import { ProductCard as UniformProductCard } from "./product-card";
export type { Product } from "./product-card";

export default UniformProductCard;
